export default __webpack_public_path__ + "static/media/qa.5adeb460.svg";